// extracted by mini-css-extract-plugin
export default {"wrapper":"PackageSlider_wrapper__Ki-DB","slider":"PackageSlider_slider__z9hG+","leftArrow":"PackageSlider_leftArrow__fSyPf","rightArrow":"PackageSlider_rightArrow__pf2fT"};